// @ts-ignore
import GLightbox from 'glightbox/dist/js/glightbox';

export class Lightbox {
  private selector: string;
  private lightboxes: NodeListOf<Element>;
  private videoLightBoxes: NodeListOf<HTMLElement>;
  private items: any[];

  constructor() {
    this.selector = 'data-lightbox';
    this.lightboxes = document.querySelectorAll('[' + this.selector + ']');
    this.items = [];
    this.init();
  }

  init() {
    const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
        <div class="gloader visible"></div>
        <div class="goverlay"></div>
        <div class="gcontainer">
        <div id="glightbox-slider" class="gslider"></div>
        <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example"><i class="im im-angle-right-circle"></i></button>
        <button class="gprev gbtn" tabindex="1" aria-label="Previous"><i class="im im-angle-left-circle"></i></button>
    </div>
    </div>`;

    let customSlideHTML = `<div class="gslide">
        <div class="gslide-inner-content">
            <div class="ginner-container">
                <button class="gclose gbtn" tabindex="2" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 30 30" x-on:click="burgerActive = 0"><path fill="#EA6F18" d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"></path></svg></button>
                <div class="gslide-media">
                </div>
                <div class="gslide-description">
                    <div class="gdesc-inner">
                        <h4 class="gslide-title"></h4>
                        <div class="gslide-desc"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>`;

    this.lightboxes.forEach((item) => {
      let groupIdentifier = item.getAttribute(this.selector);
      if (this.items.indexOf(groupIdentifier) === -1) {
        this.items.push(groupIdentifier);
      }
    });

    this.items.forEach((item) => {
      let lightbox = GLightbox({
        lightboxHTML: customLightboxHTML,
        slideHTML: customSlideHTML,

        // need this to avoid lightbox close if Usercentrics smart data protector is active
        closeOnOutsideClick: false,
        zoomable: false,

        selector: '[' + this.selector + '="' + item + '"]',
        moreLength: 0
      });

      lightbox.on('slide_after_load', (data) => {
        const {slideIndex, slideNode, slideConfig, player, trigger} = data;

        let closeButton = slideNode.querySelector('.gclose');
        if (closeButton !== null) {
          closeButton.addEventListener('click', function () {
            lightbox.close();
          });
        }
      });

      let videoLightBoxes = document.querySelectorAll('[data-lightbox-videoid]');
      if (videoLightBoxes) {
        videoLightBoxes.forEach((videoLightBox) => {
          let originalParent = videoLightBox.parentNode;
          let videoLightContent = document.querySelector('#' + videoLightBox.id + '-content');

          videoLightBox.addEventListener('click', function () {
            let lightboxContentContainer = lightbox.getActiveSlide().querySelector('.gslide-media');
            lightboxContentContainer.innerHTML = '';
            lightboxContentContainer.appendChild(videoLightContent);
            lightboxContentContainer.classList.add('h-auto');
            videoLightContent.classList.add('d-block');
          });
          lightbox.on('close', () => {
            videoLightContent.classList.remove('d-block');
            originalParent.appendChild(videoLightContent);
          });
        });
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function(event) {
  new Lightbox();
});
